import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [...Array(totalPages).keys()].map((n) => n + 1);

  return (
    <div className="flex justify-center space-x-2 mt-4">
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`px-3 py-1 rounded ${page === currentPage ? "bg-primary text-text-on-primary" : "bg-neutral-light text-text"}`}
        >
          {page}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
